import React, { useEffect, useState } from "react";
import "../styles.css";

type CoachMarkStepTwoProps = {
  visible: boolean;
  houseName?: string;
  onNext: () => void;
  targetSelector?: string;
};

const MAX_CARD_WIDTH = 320;

const CoachMarkStepTwo = ({
  visible,
  houseName = "Amethyst",
  onNext,
  targetSelector = ".header-banner",
}: CoachMarkStepTwoProps) => {
  const [position, setPosition] = useState({ top: 120, left: 12 });

  useEffect(() => {
    if (!visible) return;

    const updatePosition = () => {
      const target = document.querySelector(targetSelector) as HTMLElement | null;

      if (!target) {
        setPosition({ top: 120, left: 12 });
        return;
      }

      const rect = target.getBoundingClientRect();
      const effectiveCardWidth = Math.min(MAX_CARD_WIDTH, window.innerWidth - 24);
      const desiredTop = rect.bottom + 8;
      const maxTop = Math.max(12, window.innerHeight - 260);
      const centeredLeft = rect.left + rect.width / 2 - effectiveCardWidth / 2;
      const maxLeft = Math.max(12, window.innerWidth - effectiveCardWidth - 12);

      setPosition({
        top: Math.max(12, Math.min(desiredTop, maxTop)),
        left: Math.max(12, Math.min(centeredLeft, maxLeft)),
      });
    };

    updatePosition();
    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);

    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
  }, [targetSelector, visible]);

  if (!visible) return null;

  return (
    <div
      className="coachmark-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Coach mark step two"
    >
      <div
        className="coachmark-step-two-card"
        style={{ top: `${position.top}px`, left: `${position.left}px` }}
      >
        <div className="coachmark-step-two-inner">
          <div className="coachmark-step-two-bubble mt-3">
            <div className="coachmark-step-two-text">Congrats! You've</div>
            <div className="coachmark-step-two-text">been placed in</div>
            {houseName ? (
              <>
                <div className="coachmark-step-two-house">the {houseName}</div>
                <div className="coachmark-step-two-house"> House!</div>
              </>
            ) : (
              <div className="coachmark-step-two-house">a House!</div>
            )}
          </div>

          <img
            src={require("../../assets/Item2.png")}
            alt="U mascot"
            className="coachmark-step-two-mascot"
          />

          <button
            type="button"
            onClick={onNext}
            className="coachmark-step-two-next"
            aria-label="Next coach mark"
          >
            <img
              src={require("../../assets/pink-left-arrow.png")}
              alt=""
              aria-hidden="true"
              className=""
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CoachMarkStepTwo;
